import React from 'react';

import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

import classnames from 'classnames';

type ScrollableContainerTypes = {
    grow: boolean;
    className: string;
    children: JSX.Element;
};

function ScrollableContainer({
    grow,
    children,
    className,
    ...otherProps
}: ScrollableContainerTypes) {
    const classes = useStyles();

    return (
        <div
            className={classnames(classes.root, grow ? classes.grow : classes.fill, className)}
            {...otherProps}>
            {children}
        </div>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            overflow: 'auto',
            '&::-webkit-scrollbar': {
                width: 8,
                height: 12
            },
            '&::-webkit-scrollbar-track': {
                background: theme.palette.background.main
                // borderRadius: 4
            },
            '&::-webkit-scrollbar-thumb': {
                background: theme.palette.grey.variant3
                // borderRadius: 4
            }
        },
        fill: {
            height: '100%'
        },
        grow: {
            flexGrow: 1
        }
    })
);

export default ScrollableContainer;
